/*
 * EGR (Enhanced Genetic Research) — catalog and promotion config.
 * Edit this file to change products, prices, lots or promotions.
 * Lot numbers and purities are sample data (see the "Sample lots" badge).
 * Each product's `tone` sets its vial label accent: sky = blue, lilac = violet,
 * aqua = cyan, mint = green, butter = amber, blush = pink, peach = orange.
 */
(function () {
  var METHOD = "RP-HPLC · 220 nm";

  function lot(number, testedAt, purity, massTheoretical, massObserved, status) {
    return {
      number: number,
      status: status || "active",
      testedAt: testedAt,
      purity: purity,
      method: METHOD,
      massTheoretical: massTheoretical == null ? null : massTheoretical,
      massObserved: massObserved == null ? null : massObserved,
      identity: true,
      lab: null,
      coaUrl: null
    };
  }

  function spec(o) {
    return Object.assign({
      sequence: null, length: null, mw: null, formula: null, cas: null,
      pubchemCid: null, form: "Lyophilized powder", storageC: -20, purityMin: 99
    }, o);
  }

  window.EGR_DATA = {
    brand: {
      name: "EGR",
      fullName: "Enhanced Genetic Research",
      legalName: "EGR · Enhanced Genetic Research",
      email: "support@egr.example",
      // Business phone and mailing address. Leave empty until real; they appear in
      // the footer and on the Contact page once filled in (payment processors look for them).
      phone: "",
      address: "",
      replyTime: "within 24 hours",
      // Card and wallet badges shown in the footer. Leave empty until a payment
      // processor is connected, e.g. ["VISA", "Mastercard", "Apple Pay"].
      paymentMethods: [],
      tagline: "Research peptides, documented to the lot."
    },

    promo: {
      // Sitewide sale. When endsAt has passed the ribbon falls back to the daily list.
      sitewide: { enabled: true, percent: 40, name: "Autumn release", endsAt: "2026-10-16T03:59:00Z" },
      daily: { enabled: true, percent: 50, resetHourET: 0, maxUnitsPerLine: 5, handles: ["kpv", "semax", "selank", "dsip", "epithalon"] },
      box: { percent: 40, slots: 4, deliveries: 3, freeGiftHandle: "bac-water" },
      bulk: { tiers: [{ min: 10, percent: 40 }, { min: 50, percent: 50 }] },
      multi: { tiers: [{ min: 2, percent: 5 }, { min: 3, percent: 7.5 }] },
      freeShippingOver: 100
    },

    categories: [
      { id: "metabolic", label: "Metabolic" },
      { id: "cellular", label: "Cellular" },
      { id: "secretagogue", label: "Secretagogue" },
      { id: "neuro", label: "Neuro" },
      { id: "dermal", label: "Dermal" },
      { id: "circadian", label: "Circadian" },
      { id: "supplies", label: "Supplies" }
    ],

    products: [
      {
        id: "prod_01M45BQ5QS40K40F8DNJYKS9WG", handle: "eg-1", title: "EG-1 (SM)", short: "EG-1 (SM)",
        subtitle: "Incretin-receptor agonist peptide", category: "metabolic", tone: "sky",
        label: { ink: "#0F1115", stock: "#DCEBFF", accent: "#2D5BFF" }, kind: "vial",
        spec: spec({ mw: 4113.58, formula: "C187H291N45O59", cas: "910463-68-2", pubchemCid: "56843331", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FG35WZ2J25AYRNNXXJ", sku: "EG-EG1-10MG", title: "10 mg", mg: 10, price: 49.99, stock: 120,
            lots: [lot("2609-023", "2026-09-16", 98.67, 4113.58, 4113.48)] }
        ],
        badges: [], featuredRank: 3, aliases: ["Semaglutide", "Sema", "SM", "AN-1", "VO-1"]
      },
      {
        id: "prod_01M45BQ5QS6P78KDKHAGC6E0AA", handle: "reditide", title: "Reditide", short: "Reditide",
        subtitle: "Triple receptor agonist peptide", category: "metabolic", tone: "lilac",
        label: { ink: "#FFFFFF", stock: "#1E2A5A", accent: "#F4D57E" }, kind: "vial",
        spec: spec({
          sequence: "Y(Aib)QGTFTSDYSI(αMeL)LDK(K*)AQ(Aib)AFIEYLLEGGPSSGAPPPS-NH₂",
          mw: 4731.4, formula: "C221H342N46O68", cas: "2381089-83-2", pubchemCid: "171390338", purityMin: 98,
          modifications: "Aib at 2 and 20 · α-methyl-L-leucine at 13 · Lys17 acylated with a C20 fatty diacid through a γGlu–AEEA linker (K*) · C-terminal amide"
        }),
        variants: [
          { id: "variant_01M45BQ6FET3NGB50Z9AHK473C", sku: "EG-RDT-10MG", title: "10 mg", mg: 10, price: 69.99, stock: 120,
            lots: [lot("2609-018", "2026-09-15", 98.92, 4731.4, 4731.1)] },
          { id: "variant_01M45BQ6FF16C1QGZMHHKZ41F6", sku: "EG-RDT-20MG", title: "20 mg", mg: 20, price: 134.99, stock: 120,
            lots: [lot("2609-019", "2026-09-15", 99.37, 4731.4, 4731.2)] },
          { id: "variant_01M45BQ6FF07NZJNZ49VV6TYQW", sku: "EG-RDT-30MG", title: "30 mg", mg: 30, price: 199.99, stock: 120,
            lots: [lot("2609-020", "2026-09-15", 98.87, 4731.4, 4731.7)] }
        ],
        badges: ["bestseller"], featuredRank: 1, aliases: ["Retatrutide", "Reta", "Triple G", "GGG", "RT", "AN-3", "VO-3"]
      },
      {
        id: "prod_01M45BQ5QS9QH1T4QX1R2W22Y1", handle: "tesamorelin", title: "Tesamorelin", short: "Tesamorelin",
        subtitle: "GHRH analog", category: "secretagogue", tone: "butter",
        label: { ink: "#0F1115", stock: "#E8F2A6", accent: "#5C6B00" }, kind: "vial",
        spec: spec({ sequence: "(hexenoyl)-YADAIFTNSYRKVLGQLSARKLLQDIMSRQQGESNQERGARARL-NH₂", mw: 5135.9, formula: "C221H366N72O67S", cas: "218949-48-5", pubchemCid: "16137828", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FH8XDBQMVP76R603FP", sku: "EG-TESAMORELIN-10MG", title: "10 mg", mg: 10, price: 69.99, stock: 120,
            lots: [lot("2609-008", "2026-09-10", 98.97, 5135.9, 5135.6)] }
        ],
        badges: [], featuredRank: 5
      },
      {
        id: "prod_01M45BQ5QT1G5R6JSTQ4VQWDVV", handle: "nad-plus", title: "NAD+", short: "NAD+",
        subtitle: "Dinucleotide coenzyme", category: "cellular", tone: "blush",
        label: { ink: "#0F1115", stock: "#FBDDE6", accent: "#B0265A" }, kind: "vial",
        spec: spec({ mw: 663.43, formula: "C21H27N7O14P2", cas: "53-84-9", pubchemCid: "5892" }),
        variants: [
          { id: "variant_01M45BQ6FK9HW7VZQ9X7YV2YFY", sku: "EG-NADPLUS-500MG", title: "500 mg", mg: 500, price: 69.99, stock: 120,
            lots: [lot("2609-009", "2026-09-12", 99.74, 663.43, 663.23)] }
        ],
        badges: [], featuredRank: 8
      },
      {
        id: "prod_01M45BQ5QT3FNYMFNMP7DF34T4", handle: "bpc-157", title: "BPC-157", short: "BPC-157",
        subtitle: "Synthetic pentadecapeptide", category: "cellular", tone: "sky",
        label: { ink: "#0F1115", stock: "#C9EFD3", accent: "#16703F" }, kind: "vial",
        spec: spec({ sequence: "GEPPPGKPADDAGLV", mw: 1419.53, formula: "C62H98N16O22", cas: "137525-51-0", pubchemCid: "9941957" }),
        variants: [
          { id: "variant_01M45BQ6FM7VSE0SR7X9SGBSTP", sku: "EG-BPC157-10MG", title: "10 mg", mg: 10, price: 39.99, stock: 120,
            lots: [
              lot("2609-017", "2026-09-24", 99.62, 1419.53, 1419.83),
              lot("2608-009", "2026-08-14", 99.35, 1419.53, 1419.33, "archived")
            ] }
        ],
        badges: ["bestseller"], featuredRank: 10
      },
      {
        id: "prod_01M45BQ5QT4RSVAAHN0WDA7AS7", handle: "kpv", title: "KPV", short: "KPV",
        subtitle: "α-MSH C-terminal tripeptide", category: "cellular", tone: "aqua",
        label: { ink: "#0F1115", stock: "#BFEDE6", accent: "#0B6B64" }, kind: "vial",
        spec: spec({ sequence: "KPV", mw: 342.43, formula: "C16H30N4O4", cas: "67727-97-3" }),
        variants: [
          { id: "variant_01M45BQ6FN8T2S9AFBYZ8C03J9", sku: "EG-KPV-10MG", title: "10 mg", mg: 10, price: 39.99, stock: 120,
            lots: [lot("2608-018", "2026-08-21", 99.33, 342.43, 342.13)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QT4X20JQKP7X8X6R36", handle: "semax", title: "Semax", short: "Semax",
        subtitle: "ACTH(4–10) analog heptapeptide", category: "neuro", tone: "sky",
        label: { ink: "#0F1115", stock: "#EEF4FB", accent: "#1A62C4" }, kind: "vial",
        spec: spec({ sequence: "MEHFPGP", mw: 813.93, formula: "C37H51N9O10S", cas: "80714-61-0", pubchemCid: "9811102" }),
        variants: [
          { id: "variant_01M45BQ6FPYQ45XX4FS7BZZ1S0", sku: "EG-SEMAX-10MG", title: "10 mg", mg: 10, price: 29.95, stock: 120,
            lots: [lot("2608-027", "2026-08-28", 99.71, 813.93, 814.23)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QTG628QD9JEENX4GCG", handle: "bac-water", title: "BAC Water", short: "BAC Water",
        subtitle: "Bacteriostatic water · research supplies", category: "supplies", tone: "aqua", aliases: ["Bacteriostatic water", "Water", "H2O"],
        label: { ink: "#0F1115", stock: "#CFF3EF", accent: "#0B6B64" }, kind: "water",
        spec: spec({ form: "Sterile water, 0.9 % benzyl alcohol", storageC: 20, purityMin: null }),
        variants: [
          { id: "variant_01M45BQ6FM45YJTXHPBWKASQ1R", sku: "EG-BACWATER-10ML", title: "10 mL", mg: null, volumeMl: 10, price: 19.99, stock: 120,
            lots: [lot("2609-010", "2026-09-14", null, null, null)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QTP6YZ05DMDVSD7KE9", handle: "klow", title: "KLOW", short: "KLOW",
        subtitle: "GHK-Cu · BPC-157 · TB-500 · KPV blend", category: "cellular", tone: "mint",
        label: { ink: "#0F1115", stock: "#D5F5E1", accent: "#16703F" }, kind: "vial",
        components: [
          { name: "GHK-Cu", share: 0.625, handle: "ghk-cu" },
          { name: "BPC-157", share: 0.125, handle: "bpc-157" },
          { name: "TB-500", share: 0.125, handle: "tb-500" },
          { name: "KPV", share: 0.125, handle: "kpv" }
        ],
        spec: spec({ form: "Lyophilized powder (blend)", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FN6RTS0NW7ZDR40VZX", sku: "EG-KLOW-80MG", title: "80 mg", mg: 80, price: 99.99, stock: 120,
            lots: [lot("2609-027", "2026-09-17", 98.28, null, null)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QTRBH0C81QJQB8KPCD", handle: "glutathione", title: "Glutathione", short: "Glutathione",
        subtitle: "Tripeptide thiol (γ-Glu-Cys-Gly)", category: "cellular", tone: "butter",
        label: { ink: "#0F1115", stock: "#FFF6CC", accent: "#8A6A00" }, kind: "vial",
        spec: spec({ mw: 307.32, formula: "C10H17N3O6S", cas: "70-18-8", pubchemCid: "124886" }),
        variants: [
          { id: "variant_01M45BQ6FP0DGCEMY69GQQ4QHJ", sku: "EG-GLUTATHIONE-1500MG", title: "1.5 g", mg: 1500, price: 59.99, stock: 120,
            lots: [lot("2609-028", "2026-09-17", 99.64, 307.32, 307.02)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QTTBNJ1ESE95CFR0VJ", handle: "melanotan-ii", title: "Melanotan II", short: "Melanotan II",
        subtitle: "Cyclic melanocortin analog", category: "dermal", tone: "peach",
        label: { ink: "#FFFFFF", stock: "#7A3B1E", accent: "#FCD2B5" }, kind: "vial",
        spec: spec({ sequence: "Ac-Nle-cyclo[Asp-His-D-Phe-Arg-Trp-Lys]-NH₂", mw: 1024.18, formula: "C50H69N15O9", cas: "121062-08-6", pubchemCid: "92432", storageC: 4 }),
        variants: [
          { id: "variant_01M45BQ6FQMBXRM4355XHGQ6Z2", sku: "EG-MELANOTANII-10MG", title: "10 mg", mg: 10, price: 29.95, stock: 120,
            lots: [lot("2609-029", "2026-09-17", 99.76, 1024.18, 1023.98)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QTYR0NSVY6Z5APTR6N", handle: "mots-c", title: "MOTS-c", short: "MOTS-c",
        subtitle: "Mitochondrial-derived peptide", category: "metabolic", tone: "lilac",
        label: { ink: "#0F1115", stock: "#BFB2FF", accent: "#3A2BAA" }, kind: "vial",
        spec: spec({ sequence: "MRWQEMGYIFYPRKLR", mw: 2174.64, formula: "C101H152N28O22S2", cas: "1627580-64-6", pubchemCid: "146675088", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FJT5MPFD76BJ1YXYTS", sku: "EG-MOTSC-10MG", title: "10 mg", mg: 10, price: 39.99, stock: 120,
            lots: [lot("2609-015", "2026-09-22", 99.13, 2174.64, 2174.74)] },
          { id: "variant_01M45BQ6FK23WPZD099314X3FV", sku: "EG-MOTSC-40MG", title: "40 mg", mg: 40, price: 134.99, stock: 120,
            lots: [lot("2609-016", "2026-09-22", 99.06, 2174.64, 2174.84)] }
        ],
        badges: [], featuredRank: 7
      },
      {
        id: "prod_01M45BQ5QTZ77T5QD5CWMKME56", handle: "cjc-ipamorelin", title: "CJC-1295 / Ipamorelin (no DAC)", short: "CJC / Ipa",
        subtitle: "Mod GRF 1-29 · Ipamorelin blend", category: "secretagogue", tone: "lilac",
        label: { ink: "#0F1115", stock: "#CFC6FF", accent: "#3A2BAA" }, kind: "vial",
        components: [
          { name: "CJC-1295 (no DAC)", share: 0.5, handle: null },
          { name: "Ipamorelin", share: 0.5, handle: "ipamorelin" }
        ],
        spec: spec({ form: "Lyophilized powder (blend)", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FKX3XM3RRDAPEMV8DG", sku: "EG-CJCIPAMORELIN-10MG", title: "10 mg", mg: 10, price: 59.99, stock: 120,
            lots: [lot("2609-025", "2026-09-16", 98.84, null, null)] }
        ],
        badges: [], featuredRank: 9
      },
      {
        id: "prod_01M45BQ5QV49NNMWVN4E87JW37", handle: "5-amino-1mq", title: "5-Amino-1MQ", short: "5-Amino-1MQ",
        subtitle: "NNMT inhibitor, small molecule", category: "metabolic", tone: "butter",
        label: { ink: "#0F1115", stock: "#FDEB9C", accent: "#735600" }, kind: "vial",
        spec: spec({ mw: 159.21, formula: "C10H11N2+", cas: "42464-96-0", pubchemCid: "950107", form: "Powder (iodide salt)" }),
        variants: [
          { id: "variant_01M45BQ6FS23RSWBDNFMS8TJ94", sku: "EG-5AMINO1MQ-50MG", title: "50 mg", mg: 50, price: 49.99, stock: 120,
            lots: [lot("2609-033", "2026-09-18", 99.82, 159.21, 159.11)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QV6AAFQWZ8J4MQMF1T", handle: "melanotan-i", title: "Melanotan I", short: "Melanotan I",
        subtitle: "Linear α-MSH analog", category: "dermal", tone: "peach",
        label: { ink: "#0F1115", stock: "#F7D2B8", accent: "#8A3A12" }, kind: "vial",
        spec: spec({ sequence: "Ac-Ser-Tyr-Ser-Nle-Glu-His-D-Phe-Arg-Trp-Gly-Lys-Pro-Val-NH₂", mw: 1646.85, formula: "C78H111N21O19", cas: "75921-69-6", pubchemCid: "16197727" }),
        variants: [
          { id: "variant_01M45BQ6FRMAWACZKV8D0DCJSD", sku: "EG-MELANOTANI-10MG", title: "10 mg", mg: 10, price: 29.95, stock: 120,
            lots: [lot("2609-031", "2026-09-18", 99.93, 1646.85, 1646.55)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QV72ZAJY8SHF6F2X4X", handle: "igf-1-lr3", title: "IGF-1 LR3", short: "IGF-1 LR3",
        subtitle: "Long R3 IGF-1 analog, 83 aa", category: "secretagogue", tone: "aqua",
        label: { ink: "#FFFFFF", stock: "#0B6B64", accent: "#B5E9E3" }, kind: "vial",
        spec: spec({ sequence: "MFPAMPLSSLFVNGPRTLCGAELVDALQFVCGDRGFYFNKPTGYGSSSRRAPQTGIVDECCFRSCDLRRLEMYCAPLKPAKSA", mw: 9117.6, formula: "C400H625N111O115S9", cas: "143045-27-6", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FRCJBKYK3VDVQFBC9F", sku: "EG-IGF1LR3-1MG", title: "1 mg", mg: 1, price: 69.99, stock: 120,
            lots: [lot("2609-032", "2026-09-18", 98.7, 9117.6, 9117.4)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QVD58RD5H71AGWWGKD", handle: "wolverine", title: "Wolverine (BPC-157 / TB-500)", short: "Wolverine",
        subtitle: "BPC-157 · TB-500 blend", category: "cellular", tone: "sky",
        label: { ink: "#FFFFFF", stock: "#1A3FD6", accent: "#F4D57E" }, kind: "vial",
        components: [
          { name: "BPC-157", share: 0.5, handle: "bpc-157" },
          { name: "TB-500", share: 0.5, handle: "tb-500" }
        ],
        spec: spec({ form: "Lyophilized powder (blend)", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FS0HJD5PHH6B40TRBR", sku: "EG-WOLVERINE-10MG", title: "10 mg", mg: 10, price: 79.99, stock: 120,
            lots: [lot("2609-034", "2026-09-18", 99.57, null, null)] },
          { id: "variant_01M45BQ6FSJP34BJD1QSDDFPX4", sku: "EG-WOLVERINE-20MG", title: "20 mg", mg: 20, price: 149.99, stock: 120,
            lots: [lot("2609-035", "2026-09-18", 98.75, null, null)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QVFCVHMRFZ90AXYRM2", handle: "glow", title: "GLOW", short: "GLOW",
        subtitle: "GHK-Cu · BPC-157 · KPV blend", category: "dermal", tone: "blush",
        label: { ink: "#0F1115", stock: "#FFE1EC", accent: "#C7366E" }, kind: "vial",
        components: [
          { name: "GHK-Cu", share: 0.7143, handle: "ghk-cu" },
          { name: "BPC-157", share: 0.1429, handle: "bpc-157" },
          { name: "KPV", share: 0.1429, handle: "kpv" }
        ],
        spec: spec({ form: "Lyophilized powder (blend)", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FQ84TYB89JG9QPG6BV", sku: "EG-GLOW-70MG", title: "70 mg", mg: 70, price: 89.99, stock: 120,
            lots: [lot("2609-030", "2026-09-17", 98.53, null, null)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QVG5Y28FVXFSN67SPJ", handle: "tb-500", title: "TB-500", short: "TB-500",
        subtitle: "Thymosin β4 peptide", category: "cellular", tone: "sky",
        label: { ink: "#0F1115", stock: "#CFE4FB", accent: "#1A62C4" }, kind: "vial",
        spec: spec({ sequence: "Ac-SDKPDMAEIEKFDKSKLKKTETQEKNPLPSKETIEQEKQAGES", mw: 4963.44, formula: "C212H350N56O78S", cas: "77591-33-4", pubchemCid: "16132341", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FR3VJ9E899EKKF4BXX", sku: "EG-TB500-10MG", title: "10 mg", mg: 10, price: 39.99, stock: 120,
            lots: [
              lot("2609-012", "2026-09-16", 99.21, 4963.44, 4963.24),
              lot("2607-030", "2026-07-24", 98.96, 4963.44, 4963.74, "archived")
            ] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QVMEKZNWGHAKZ6VM2W", handle: "selank", title: "Selank", short: "Selank",
        subtitle: "Tuftsin analog heptapeptide", category: "neuro", tone: "lilac",
        label: { ink: "#0F1115", stock: "#F2EFFF", accent: "#4C3DC7" }, kind: "vial",
        spec: spec({ sequence: "TKPRPGP", mw: 751.87, formula: "C33H57N11O9", cas: "129954-34-3", pubchemCid: "11765600" }),
        variants: [
          { id: "variant_01M45BQ6FQXD877NNFSBCXPE9W", sku: "EG-SELANK-10MG", title: "10 mg", mg: 10, price: 29.95, stock: 120,
            lots: [lot("2609-001", "2026-09-02", 99.49, 751.87, 751.57)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QVWJZ092D8F06M3EVW", handle: "cagrilintide", title: "Cagrilintide", short: "Cagrilintide",
        subtitle: "Acylated amylin analog", category: "metabolic", tone: "peach",
        label: { ink: "#0F1115", stock: "#FFE9DA", accent: "#A44814" }, kind: "vial",
        spec: spec({ mw: 4409, formula: "C194H312N54O59S2", cas: "1415456-99-3", pubchemCid: "171397054", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FT6HSZD3PV7SSJP1VX", sku: "EG-CAGRILINTIDE-10MG", title: "10 mg", mg: 10, price: 69.99, stock: 120,
            lots: [lot("2609-036", "2026-09-19", 98.5, 4409, 4409.2)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QW1113NA03ZGGGSBQX", handle: "epithalon", title: "Epithalon", short: "Epithalon",
        subtitle: "Tetrapeptide bioregulator", category: "cellular", tone: "mint",
        label: { ink: "#0F1115", stock: "#EEF8F0", accent: "#16703F" }, kind: "vial",
        spec: spec({ sequence: "AEDG", mw: 390.35, formula: "C14H22N4O9", cas: "307297-39-8", pubchemCid: "219042" }),
        variants: [
          { id: "variant_01M45BQ6FV15FTB25PMXJ0M8A9", sku: "EG-EPITHALON-10MG", title: "10 mg", mg: 10, price: 29.99, stock: 120,
            lots: [lot("2608-031", "2026-08-30", 99.66, 390.35, 390.05)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QWC16RHWMG48DXN514", handle: "dsip", title: "DSIP", short: "DSIP",
        subtitle: "Delta sleep-inducing peptide", category: "circadian", tone: "lilac",
        label: { ink: "#FFFFFF", stock: "#2B2146", accent: "#CFC4FF" }, kind: "vial",
        spec: spec({ sequence: "WAGGDASGE", mw: 848.81, formula: "C35H48N10O15", cas: "62568-57-4", pubchemCid: "68816" }),
        variants: [
          { id: "variant_01M45BQ6FVD3RN28KK4GMS575D", sku: "EG-DSIP-5MG", title: "5 mg", mg: 5, price: 29.99, stock: 120,
            lots: [lot("2608-024", "2026-08-26", 99.42, 848.81, 848.81)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QWGRBVVQRMWFHJV9GX", handle: "ipamorelin", title: "Ipamorelin", short: "Ipamorelin",
        subtitle: "Ghrelin receptor agonist pentapeptide", category: "secretagogue", tone: "lilac",
        label: { ink: "#0F1115", stock: "#DCD5FF", accent: "#4C3DC7" }, kind: "vial",
        spec: spec({ sequence: "Aib-His-D-2Nal-D-Phe-Lys-NH₂", mw: 711.85, formula: "C38H49N9O5", cas: "170851-70-4", pubchemCid: "9831659" }),
        variants: [
          { id: "variant_01M45BQ6FVW8WPK0XYCMZC283G", sku: "EG-IPAMORELIN-10MG", title: "10 mg", mg: 10, price: 49.99, stock: 120,
            lots: [lot("2609-004", "2026-09-04", 99.47, 711.85, 711.85)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QX443P4Z1EF30EKDKF", handle: "kisspeptin-10", title: "Kisspeptin-10", short: "Kisspeptin",
        subtitle: "KISS1R agonist decapeptide", category: "secretagogue", tone: "blush",
        label: { ink: "#FFFFFF", stock: "#E23A5B", accent: "#FFD3DD" }, kind: "vial",
        spec: spec({ sequence: "YNWNSFGLRF-NH₂", mw: 1302.44, formula: "C63H83N17O14", cas: "374675-21-5", pubchemCid: "25240297", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FZPY7JAZ36KGCRR7BF", sku: "EG-KISSPEPTIN10-10MG", title: "10 mg", mg: 10, price: 49.99, stock: 120,
            lots: [lot("2609-013", "2026-09-18", 99.22, 1302.44, 1302.34)] }
        ],
        badges: []
      },
      {
        id: "prod_01M45BQ5QXVGNW43CCQ6YYZAC6", handle: "sermorelin", title: "Sermorelin", short: "Sermorelin",
        subtitle: "GHRH(1–29) analog", category: "secretagogue", tone: "lilac",
        label: { ink: "#0F1115", stock: "#EEEAFF", accent: "#4C3DC7" }, kind: "vial",
        spec: spec({ sequence: "YADAIFTNSYRKVLGQLSARKLLQDIMSR-NH₂", mw: 3357.9, formula: "C149H246N44O42S", cas: "86168-78-7", pubchemCid: "16132413", purityMin: 98 }),
        variants: [
          { id: "variant_01M45BQ6FZPK7QQQYWT3PP4K1D", sku: "EG-SERMORELIN-10MG", title: "10 mg", mg: 10, price: 59.99, stock: 120,
            lots: [lot("2609-047", "2026-09-21", 98.36, 3357.9, 3358.2)] }
        ],
        badges: []
      },
      {
        id: "prod_01M4C66ASXGJFZB2F6JDSMNBK6", handle: "ghk-cu", title: "GHK-Cu", short: "GHK-Cu",
        subtitle: "Copper peptide", category: "dermal", tone: "aqua",
        label: { ink: "#FFFFFF", stock: "#2A6FDB", accent: "#BFE0FF" }, kind: "vial",
        spec: spec({ sequence: "GHK · Cu²⁺", mw: 401.91, formula: "C14H22CuN6O4", cas: "89030-95-5", form: "Lyophilized powder (blue)" }),
        variants: [
          { id: "variant_01M4C66B0KGE76WA63B4W1EXJK", sku: "EG-GHKCU-50MG", title: "50 mg", mg: 50, price: 29.99, stock: 120,
            lots: [lot("2609-006", "2026-09-09", 99.87, 401.91, 402.11)] },
          { id: "variant_01M4C66B0KQRCBFC0XEG6SFJYT", sku: "EG-GHKCU-100MG", title: "100 mg", mg: 100, price: 57.99, stock: 120,
            lots: [lot("2609-007", "2026-09-09", 99.81, 401.91, 402.21)] }
        ],
        badges: ["bestseller"], featuredRank: 4
      }
    ]
  };
})();
